const blacklistedEmail = window.customerData ? window.customerData?.blacklistedEmail : null;
const appEntryPoint = window.customerData ? window.customerData?.appEntryPoint : null;
const qrBaseUrl = window.customerData ? window.customerData?.qrBaseUrl : null;
const subscriberMeAPI = apiBase ? apiBase + "/subscribers/me" : null;
const shopifyGBRefreshHash = window.customerData ? window.customerData?.CustomerMetaFieldRefreshHash : null;
const shopifyGBRefreshdate = window.customerData ? window.customerData?.CustomerMetaFieldgbRefreshDate : null;
const InventoryCheck = apiBase ? apiBase + "/inventory/check" : null;

const cacheAPI = apiBase ? apiBase + "/cache?customerId=" + window.customerData.customerId : null

const subscribersSettingsLanguage = apiBase ? apiBase + "/subscribers/settings/language" : null;
const subscribersSettingsCurrency =  apiBase ? apiBase + "/subscribers/settings/currency" :null;
const shopDomain = window.customerData ? window.customerData?.shopifyShopDomain : null


let _gbTokenUpdating = null; // Lock to prevent multiple simultaneous refreshes
let detailPopupSelectedVariantId = null;
// store cache data 
let cacheData = null;
const updateGBToken = async () => {
    console.log("**shop domain** == ",shopDomain);
  // Return early if another refresh is in progress
  if (_gbTokenUpdating) {
    console.log(" Waiting for ongoing token update...");
    return _gbTokenUpdating;
  }

  _gbTokenUpdating = (async () => {
    // console.log("Starting updateGBTokenNew");

    try {
      const refreshTokenAPI = apiBase ? apiBase + '/subscribers/token/refreshToken' : null;
      if (!refreshTokenAPI) {
        console.error(" No refresh token API defined");
        return null;
      }

      const refreshWithToken = async (refreshToken) => {
        // console.log("Refreshing token with:", refreshToken);
        try {
          const body = new URLSearchParams({ refreshToken, keepMeLoggedIn: 'true' });
          const response = await fetch(refreshTokenAPI, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString(),
          });

          if (!response.ok) {
            console.error("Error calling refreshTokenAPI", response.status);
            return null;
          }

          const data = await response.json();
          // console.log("refreshWithToken response data:", data);

          if (!data.token) {
            console.warn(" No token returned from refresh API");
            return null;
          }

          const tokenMillis = parseExpiryToMillis(data.tokenExpiresIn || '0s');
          const refreshMillis = parseExpiryToMillis(data.refreshTokenExpiresIn || '0s');

          localStorage.setItem('gbToken', data.token);
          localStorage.setItem('gbTokenExpiresIn', String(Date.now() + tokenMillis));
          localStorage.setItem('gbRefreshToken', data.refreshToken || '');
          localStorage.setItem('gbRefreshTokenExpiresIn', String(Date.now() + refreshMillis));

          // console.log(" Tokens saved to localStorage");
          return data.token;
        } catch (err) {
          console.error("Error refreshing with token:", err);
          return null;
        }
      };

      // --- Step 1: Access token still valid ---
      let gbToken = localStorage.getItem('gbToken') || null;
      const gbTokenExpiresIn = Number(localStorage.getItem('gbTokenExpiresIn') || 0);

      if (gbToken && gbTokenExpiresIn > Date.now()) {
        console.log("Access token still valid");
        return gbToken;
      }

      // --- Step 2: Local refresh token ---
      const gbRefreshToken = localStorage.getItem('gbRefreshToken');
      const gbRefreshTokenExpiresIn = Number(localStorage.getItem('gbRefreshTokenExpiresIn') || 0);

      if (gbRefreshToken && gbRefreshTokenExpiresIn > Date.now()) {
        console.log("Using local refresh token and calling GB refresh token api");
        const token = await refreshWithToken(gbRefreshToken);
        if (token) return token;
      }

      // --- Step 3: Shopify metafield refresh token ---
      // if (shopifyGBRefreshHash && new Date(shopifyGBRefreshdate).getTime() > Date.now()) {
      //   console.log("Using Shopify metafield refresh token and calling GB api");
      //   const token = await refreshWithToken(shopifyGBRefreshHash);
      //   if (token) return token;
      // }

      const REFRESH_BUFFER_MS = 2 * 60 * 1000; // 2 minutes buffer

      if (shopifyGBRefreshHash && shopifyGBRefreshdate) {
        const refreshExpiry = new Date(shopifyGBRefreshdate).getTime();

        // Run only if token is still valid for more than 2 minutes
        if (refreshExpiry - REFRESH_BUFFER_MS >= Date.now()) {
          console.log("Using Shopify metafield refresh token (valid >2 min) — calling GB API");
          const token = await refreshWithToken(shopifyGBRefreshHash);
          if (token) return token;
          
        } else if (refreshExpiry > Date.now()) {
          console.warn("Shopify metafield token within 2 min of expiry — skipping to fallback refresh");
        } else {
          console.warn("Shopify metafield token expired — skipping to fallback refresh");
        }
      }
      // --- Step 4: Fallback Shopify API ---
      const customerEmail = window.customerData?.email || null;
      if (!customerEmail) {
        console.error(" No customer email found");
        return null;
      }

      const shopifyRefreshTokenApi = appEntryPoint ? appEntryPoint + "/app/api/refreshtoken" : null;
      if (!shopifyRefreshTokenApi) {
        console.error("No Shopify refresh token API defined");
        return null;
      }
      // console.log("calling refresh token api of shopify");
      try {
        const formData = new FormData();
        formData.append("email", customerEmail);

        await new Promise((resolve) => setTimeout(resolve, 5000));
        const response = await fetch(shopifyRefreshTokenApi, {
          method: "POST",
          body: formData,
          headers: {
              "x-shop-custom-domain": shopDomain,
           }
        });

        // console.log("response,,,,,, from remix api",response);
        if (!response.status == 200) {
          console.error("Shopify API failed", response.data);
          return null;
        }

        const data = await response.json();
        // console.log(" Shopify API response:", data);

        if (data === true) {
          console.log("inside true condition");
          setTimeout(() => {
                  window.location.reload();
              }, 50);
        }
        else {
          console.warn("Shopify API fallback did not return a token");
          return null;
        }
      } catch (err) {
        console.error("Error calling Shopify refresh API:", err);
        return null;
      }
    } catch (err) {
      console.error("Unexpected error in updateGBTokenNew:", err);
      return null;
    } finally {
      _gbTokenUpdating = null; // release lock
    }
  })();

  return _gbTokenUpdating;
};

function parseExpiryToMillis(expiresInStr) {
  if (!expiresInStr) return 0;

  expiresInStr = expiresInStr.toString().trim();

  const match = expiresInStr.match(/^(\d+)([smhd])?$/i);
  if (!match) return 0;

  const value = parseInt(match[1], 10);
  const unit = match[2] ? match[2].toLowerCase() : 's'; // default to seconds

  switch (unit) {
    case 's':
      return value * 1000;
    case 'm':
      return value * 60 * 1000;
    case 'h':
      return value * 60 * 60 * 1000;
    case 'd':
      return value * 24 * 60 * 60 * 1000;
    default:
      return 0;
  }
}

// based on subscrib me responce auto select currency and lang
// auto select language as per customer
function switchLanguage(langCode) {
  const languageForm = document.getElementById('HeaderLanguageForm');
  if (languageForm) {
    const langInput = languageForm.querySelector('input[name="locale_code"]');
    if (langInput) {
      langInput.value = langCode;
      languageForm.submit();
    }
  }
}
// auto select currecy
function switchCurrency(currencyCode) {
  const countryForm = document.getElementById('HeaderCountryForm');
  if (countryForm) {
    const countryInput = countryForm.querySelector('input[name="country_code"]');
    if (countryInput) {
      // Find the country that uses this currency
      const countryCards = document.querySelectorAll('.country-card');
      for (let card of countryCards) {
        const currencyInfo = card.getAttribute('data-countryCurrency');
        if (currencyInfo && currencyInfo.includes(currencyCode)) {
          countryInput.value = card.getAttribute('data-code');
          countryForm.submit();
          break;
        }
      }
    }
  }
}
//both
function updateSettings({ langCode = null, currencyCode = null }) {
  const settingsForm = document.getElementById("HeaderSettingsForm");

  if (!settingsForm) return;

  // Set language
  if (langCode) {
    const langInput = settingsForm.querySelector('input[name="locale_code"]');
    if (langInput) {
      langInput.value = langCode;
    }
  }

  // Set country based on currency
  if (currencyCode) {
    const countryInput = settingsForm.querySelector('input[name="country_code"]');
    if (countryInput) {
      const countryCards = document.querySelectorAll(".country-card");
      for (let card of countryCards) {
        const currencyInfo = card.getAttribute("data-countryCurrency");
        if (currencyInfo && currencyInfo.includes(currencyCode)) {
          countryInput.value = card.getAttribute("data-code");
          break;
        }
      }
    }
  }

  // Submit once
  settingsForm.submit();
}



const subscriberMe = async () => {

  try {
    const gbToken = await updateGBToken();
    //  console.log("gb token in subscribers me",gbToken)
    const response = await fetch(subscriberMeAPI, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${gbToken}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      console.error("Error in subscribers/me API FAIL check netwoork for more info");
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error("Error in subscriberMe:", error);
    return null;
  }
}

const getInventoryCheck = async (selectedPreferredImsiId) => {
  try {
    if (!selectedPreferredImsiId) {
      console.log('IMSID :', selectedPreferredImsiId);
      return null;
    }
    // const gbToken = await updateGBToken();

    const customerId = window.customerData.customerId;

    const completeUrl = `${InventoryCheck}?customerId=${encodeURIComponent(customerId)}&imsi=${selectedPreferredImsiId}`;

    const response = await fetch(completeUrl, {
      method: 'GET',
    });

    if (!response.ok) {
      console.log('Error while checking inventory...');
      return null;
    }

    const result = await response.json();
    console.log('Inventory check result:', result);
    return result;
  } catch (error) {
    console.error('Inventory check failed:', error);
    return null;
  }
};

// get cache 
const getCacheData = async () => {
  try {
    const response = await fetch(cacheAPI, {
    });
    if (!response.ok) {
      console.error('error response:', response)
      return null;
    }
    const res = response.json();
    return res;
  } catch (err) {
    console.log('error while fetching cache data'.err);
    return null
  }
}

// subscriber setting language api 
const submitSubscribersSettingsLanguage = async (formData) => {
  console.log("called", formData);
  const gbToken = await updateGBToken();
  try {
    const response = await fetch(subscribersSettingsLanguage, {
      method: "POST",
       headers: {
        'Authorization': `Bearer ${gbToken}`,
      },
      body: formData
    });

    if (!response.ok) {
      console.log("submitSubscribersSettingsLanguage failed:", response.status, response.statusText);
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
  } finally {
    console.log("finally");
  }
};
// /subscribers/settings/currency
const submitSubscribersSettingsCurrency = async (formData) => {
  console.log("called", formData);
  const gbToken = await updateGBToken();
  try {
    const response = await fetch(subscribersSettingsCurrency, {
      method: "PUT",
       headers: {
        'Authorization': `Bearer ${gbToken}`,
      },
      body: formData
    });

    if (!response.ok) {
      console.log("submitSubscribersSettingsCurrency failed:", response.status, response.statusText);
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error("API Error:", error);
  } finally {
    console.log("finally");
  }
};
    //date formater
function formatDate(isoDateString) {
  if (!isoDateString) return 'N/A';
  const date = new Date(isoDateString);
  if (Number.isNaN(date.getTime())) return 'N/A';

  const parts = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  }).formatToParts(date);

  const day = parts.find(p => p.type === 'day')?.value;
  let month = parts.find(p => p.type === 'month')?.value || '';
  const year = parts.find(p => p.type === 'year')?.value;

  // normalize month to 3 letters (handles "Sept" -> "Sep") and remove any dots
  month = month.replace(/\./g, '').slice(0, 3);

  return `${day} ${month}, ${year}`;
}

// dataused formatter after decimal only 2 digit 
function formatUsage(val) {
  return Number(val).toString().replace(/(\.\d{2})\d+$/, '$1');
}
// Get the value from the URL to proceed checkout
const urlParams = new URLSearchParams(window.location.search);
console.log('urlParams-->',urlParams)
const uniqueParams = new URLSearchParams();
for (const [key, value] of urlParams.entries()) {
  if (!uniqueParams.has(key)) {
    uniqueParams.set(key, value);
  }
}
console.log('uniqueParams', uniqueParams.toString());
// quick go to checkout function 
// called this from the plan details page
const goToCheckoutFromBuyNow = async (selectedProductTitle, selectedProductId, selectedCountryKey, selectedCurrencyKey, selectedVariantId, selectedPreferredImsiId) => {
  // gtm buynow triggered
  if (selectedProductTitle && selectedProductId && selectedCountryKey && selectedCurrencyKey) {
    buyNowClicked(selectedProductTitle, selectedProductId, selectedCountryKey, selectedCurrencyKey);
  } else {
    console.log('selected keys value not fount for the GTM');
  }
  // if going to checkout form the plan details popup asing veriant id 
  detailPopupSelectedVariantId = selectedVariantId;

  // ----------code start for Choose the eSIM you want to purchase a plan for
  const esimsData = await getMyESIMData(); // assuming this is async
  // rander card first
  await renderESIMCards(esimsData, selectedPreferredImsiId)
  //match any imsi id 
  let eSIM = esimsData?.find(esim => esim?.imsiId === Number(selectedPreferredImsiId));
  console.log(eSIM?.imsiId, selectedPreferredImsiId)

  if (eSIM?.imsiId == selectedPreferredImsiId) {
    // do not show select esim for old user
    console.log('url params', uniqueParams.get('newesim'), uniqueParams.get('esimId'));
    if (uniqueParams.get('newesim') == 'true' || uniqueParams.get('esimId')) {
      document.getElementById('esim_purchase_popup').classList.add('hidden');
    } else if (esimsData && esimsData.length > 0) {
      // close quick add modal if open
      const quickModal = document.querySelector('quick-add-modal[open]');
      if (quickModal) {
        quickModal.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        // quickModal.style.display = 'none';
      }
      document.getElementById('esim_purchase_popup').classList.remove('hidden');
      return true
    }
  } else {
    console.log('not metched Imsi ID ', eSIM?.imsiId, selectedPreferredImsiId)
  }
  // ----------code end  for Choose the eSIM you want to purchase a plan for



  if (!selectedVariantId) {
    console.log('selected VariantId check failed. Cannot proceed to checkout.');
  }
  // check inventory
  console.log('selectedPreferredImsiId', selectedPreferredImsiId);
  const inventoryOk = await getInventoryCheck(selectedPreferredImsiId);
  console.log(inventoryOk, 'inventoryOk');
  if (!inventoryOk || inventoryOk?.available == false) {
    document.getElementById('common_warning').classList.remove('hidden');
    document.getElementById('common_warning_msg').textContent = 'There are no eSIMs in available-state, please contact the support team';
    console.log('Inventory check failed. Cannot proceed to checkout.');
    setTimeout(() => {
      document.getElementById('common_warning').classList.add('hidden');
    }, 3000);
    return false;
  }
  // Redirect directly to checkout with selected variant
  const localized_url = window.localizedUrlRoot || '/';
  const pageUrl = window.location.origin + `${localized_url}/cart/${selectedVariantId}:1`
  initiateCheckout(selectedCountryKey, selectedProductTitle, pageUrl)
  window.location.href = `${localized_url}/cart/${selectedVariantId}:1`;
};
// --- end quick checkout
// gtm-events.js
window.dataLayer = window.dataLayer || [];
//common function that push the GTM 
function pushGTMEvent(eventObj) {
  console.log('called GTM Event', eventObj);
  window.dataLayer.push(eventObj);
  console.log('GTM event pushed:', eventObj);
}
// gtm-event fired based on url
const gbpath = window.location.pathname;
const gbHref = window.location.href;

//1. first checkout
// Detect first visit
if (!localStorage.getItem('hasVisited')) {
  pushGTMEvent({
    event: 'first_visit',
    platform: 'Web',
    pagePath: window.location.pathname,
  });

  // Mark that the user has visited so it doesn't fire again
  localStorage.setItem('hasVisited', 'true');
}

//2. contect us page 
if (gbpath.includes('/pages/contact-us')) {
  pushGTMEvent({
    event: 'contact_us_page',
    platform: 'Web',
    pageUrl: gbHref,
    pageTitle: 'Help '
  });
}
//3. global plan 
if (gbpath.includes('/pages/global-esim')) {
  pushGTMEvent({
    event: 'global_plan_list',
    platform: 'Web',
    plan_list: plansList,
    pageUrl: gbHref
  });
}

//4. faq page
if (gbpath.includes('/pages/faq')) {
  pushGTMEvent({
    event: 'faq_page_view',
    platform: 'Web dev',
    pageUrl: gbHref,
    pageTitle: 'I have FAQ'
  });
}

//5. 6. this fuction for country and region list
function pushCountryRegion(count, type) {
  if (gbpath.includes('/pages/destination')) {
    if (type && type == 'region') {
      pushGTMEvent({
        event: 'region_list',
        platform: 'Web',
        region_list: count,
        pageUrl: gbHref
      });
    }
    else if (type && type == 'country') {
      pushGTMEvent({
        event: 'country_list',
        platform: 'Web',
        country_list: count,
        pageUrl: gbHref
      });
    }
  }
}

//7. this is for country select 
const disallowedRegions = ['asia', 'caribbean', 'europe', 'latin-america', 'middle-east', 'north-america', 'oceania', 'global'];
const match = gbpath.match(/^\/collections\/([^\/]+)\/?$/);
if (match) {
  const segment = match[1].toLowerCase();
  console.log(segment, 'segment-----')
  if (!disallowedRegions.includes(segment)) {
    pushGTMEvent({
      event: 'country_select',
      platform: 'Web',
      selectedCountry: segment,
      pageUrl: window.location.href
    });
  }
}

// 8. contect submit 
function contactUsSubmission(name, email) {
  pushGTMEvent({
    event: 'contact_us_submission',
    platform: 'Web',
    name: name,
    email: email,
    pageUrl: window.location.href
  });
}

// 9 planDetails
function planDetails(name, country, price, currency) {
  console.log('plan details ----->', currency);
  pushGTMEvent({
    event: 'plan_details',
    platform: 'Web',
    productName: name,
    country: country,
    productPrice: price,
    pageUrl: window.location.href,
    currency: currency
  });
}

// 10 When user clicks on buy now button 
function buyNowClicked(name, productId, country, currency) {
  pushGTMEvent({
    event: 'plan_buy',
    platform: 'web',
    plan_name: name,
    product_id: productId,
    country: country,
    currency: currency
  });
};

// 11. search_result_select
function searchResultSelect(name) {
  pushGTMEvent({
    event: 'search_result_select',
    platform: 'web',
    selectedCountry: name,
    pageUrl: window.location.href,
  });
};

// 12. sing in 
if ((location.pathname.startsWith('/account') || window.customerData.email) && sessionStorage.getItem('loginFlag') === '1') {
  console.log('login successs------>');
  pushGTMEvent({
    event: 'sign_in',
    platform: 'Web',
    email: window.customerData ? window.customerData.email : '',
    pageUrl: window.location.href,
    userStatus: 'logged_in',
  });
  sessionStorage.removeItem('loginFlag');
}


//13. sing up
if (window.customerData.email && sessionStorage.getItem('signupFlag') === '1') {
  pushGTMEvent({
    event: 'sign_up',
    platform: 'web',
    email: window.customerData.email,
    pageUrl: window.location.href,
  });
  sessionStorage.removeItem('signupFlag');

};

// 14. initiate_checkout	When user lands on the Order Summary screen	
function initiateCheckout(country, name, pageUrl) {
  console.log(country, name, pageUrl, 'this is intiated checkout');
  pushGTMEvent({
    event: 'initiate_checkout',
    platform: 'Web',
    countryName: country,
    planName: name,
    pageUrl: pageUrl,
  });
}

// gtm functions end 

// global function for first name
function validateName(input, error) {
  let value = input.value.trim(); // normalize spaces

  // 1. Required field check
  if (!value) {
    error.textContent = window.updateUserAccount.first_name_required || 'First name is required';
    error.classList.remove('hidden');
    return false;
  }

  // 2. Max length check (after trimming)
  if (value.length > 32) {
    error.textContent = window.updateUserAccount.fn_txt_limit || 'First name cannot be longer than 32 characters!';
    error.classList.remove('hidden');
    return false;
  }


  error.textContent = '';
  error.classList.add('hidden');
  return true;
}

function validateLastName(input, error) {
  let value = input.value.trim(); // normalize spaces

  if (!value) {
    error.textContent = window.updateUserAccount.last_name_required || 'Last name is required';
    error.classList.remove('hidden');
    return false;
  }

  if (value.length > 32) {
    error.textContent = window.updateUserAccount.ln_txt_limit || 'Last name cannot be longer than 32 characters!';
    error.classList.remove('hidden');
    return false;
  }


  error.textContent = '';
  error.classList.add('hidden');
  return true;
}

//------- set cookies ----
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
// get cookies 
function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Delete cookie
function eraseCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
// ----cookies functions end ----

// document.addEventListener("DOMContentLoaded", async () => {
let sessionData = JSON.parse(sessionStorage.getItem("guest_user_session"));
const sessionManage = async () => {
  // get session data from sessionStorage
  let sessionData = JSON.parse(sessionStorage.getItem("guest_user_session"));

  // call your API for current subscriber
  const subscriber_me = await subscriberMe();

  if (!sessionData) {
    return; // nothing to do if no session
  }

  // user redirection based session
  const localized_url = window.localizedUrlRoot || '/';


  if (sessionData && sessionData?.clicked_verify_identity == true && subscriber_me && subscriber_me?.verifiedAccount == true) {
    //1.then redirect to click page with selected plan Id
    //  window?.location?.origin = sessionData?.page + `?selectedVariantId=${selectedVariantId}`
    // cleaned the session
    sessionStorage.removeItem("guest_user_session");
    // now check if eKycStatus form the subscripme
    if (['failed', 'rejected'].includes(subscriber_me?.eKycStatus)) {
      window.location.href = `${localized_url}/pages/verification-status`;
    } else if (['ongoing'].includes(subscriber_me?.eKycStatus)) {
      window.location.href = `${localized_url}/pages/verification-initiated?status=ongoing`;
    } else if(['success','verified'].includes(subscriber_me?.eKycStatus)){
window.location.href = `${sessionData?.page}?selectedVariantId=${sessionData?.selectedVariantId}`;
    }else {
      // window.location.href = '/pages/verification-instructions';
    }
  } else if (sessionData && sessionData?.clicked_verify_identity == true && subscriber_me && subscriber_me?.verifiedAccount == false) {
    //2. if email not verified then redirect to selected plan 
    // cleaned the session
    sessionStorage.removeItem("guest_user_session");
    let redirectionQuery = sessionData?.selectedVariantId ? `?selectedVariantId=${sessionData?.selectedVariantId}` : ''
    window.location.href = sessionData?.page + redirectionQuery;
  } else {
    console.log('')
  }
  // ---end clicked_verify_identity code
  let sessioncheckoutUrl = sessionStorage.getItem('checkout_url');

 if (sessionData && sessioncheckoutUrl && sessionData?.clicked_non_verify_identity === true) {
  if (subscriber_me && subscriber_me?.verifiedAccount === true) {
    // extract only the value part of checkout_url=...
    const urlParams = new URLSearchParams(sessioncheckoutUrl);
    const checkoutPath = urlParams.get('checkout_url'); // e.g. "/checkouts/cn/hWN2ssGj298PzdV4FRwtqllJ/en-in?cart_link_id=..."
    if (checkoutPath) {
       sessionStorage.removeItem("guest_user_session");
      sessionStorage.removeItem("checkout_url")
      window.location.href = decodeURIComponent(checkoutPath);
    }
  }else {
      sessionStorage.removeItem("guest_user_session");
      sessionStorage.removeItem("checkout_url");
      let redirectionQuery = sessionData?.selectedVariantId ? `?selectedVariantId=${sessionData?.selectedVariantId}` : ''
    window.location.href = sessionData?.page + redirectionQuery;
    
    }
  }
}

// if checkout_url in the url remove from the url and store in the session 
// and reload the website
if (uniqueParams.has('checkout_url') && !sessionStorage.getItem('checkout_url')) {
  // set sesstion 
  sessionStorage.removeItem("checkout_url");
  sessionStorage.setItem("checkout_url",uniqueParams.toString());
  const data = sessionStorage.getItem("checkout_url");
  console.log("checkout url......",data);
// Get current URL
let url = new URL(window.location.href);

// Remove the checkout_url param
url.searchParams.delete("checkout_url");

// Update the browser address bar (no reload)
window.history.replaceState({}, document.title, url);
// end remove checkout_url code
  window.location.reload(true);

} else {
  console.log('not include checkout_urlcheckout_url');
}

// call only when userd logged in
if (window.customerData?.email && sessionData) {
  sessionManage()
}